import {CommandeFormationStore} from "./../../common/store/commande-formation.store";
import {CommandeFormationDto, ICommandeFormationWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";

@Injectable()
export class CommandeFormationResolver implements Resolve<void> {

  constructor(private commandeFormationWebServiceClient: ICommandeFormationWebServiceClient,
              private commandeFormationStore: CommandeFormationStore) {
  }

  resolve() {
    let commandeFormation: CommandeFormationDto = this.commandeFormationStore.getCommandeFormation();
    if (commandeFormation != null) {
      // si on a une commande on essaye de supprimer la commande
      this.commandeFormationWebServiceClient.deleteCommandeFormation(commandeFormation.id, {notFinish: true}).subscribe(data => {
        // on vide la commande locale
        this.commandeFormationStore.emptyCommandeFormation(false);
        if (!data) {
          // si la réponse de suppression est non alors c'est que la commande est terminée et on doit vider la préparation de commande
          this.commandeFormationStore.emptySaveCommandeFormation();
        }
      });
    }
    //return Observable.empty();
    //return Observable.of(false);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/commande-formation.resolver.ts